import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { UserService } from "app/shared/services";
import { ErrorsFormatterUtilService } from "app/shared/services/errors-formatter-util.service";
import { Router } from "@angular/router";

@Component ( {
  selector: 'reporter-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
} )
export class ForgotPasswordComponent {
  customerMessageError = '';
  failed = false;
  forgotPasswordForm: FormGroup;
  @Output () onBackToLogin = new EventEmitter<void> ();

  constructor (
    private userService: UserService,
    private errorFormatter: ErrorsFormatterUtilService,
    private router: Router,
  ) {
    this.forgotPasswordForm = new FormGroup ( {
      userSearchTerm: new FormControl ( null, [ Validators.required ] ),
    } );
  }

  onSubmitForgotPasswordForm () {
    this.router.navigate ( [ '/recover' ], {
      queryParams: { ust: btoa ( this.forgotPasswordForm.value.userSearchTerm ) },
    } ).then ( null );
  }

  backToLogin () {
    this.failed = false;
    this.customerMessageError = '';
    this.onBackToLogin.emit ();
  }
}
